function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "desktop",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(-2, -1)"
}, React.createElement("path", {
  d: "M6,1 C4.0675,1 2.5,2.5675 2.5,4.5 C2.5,7.125 6,11 6,11 C6,11 9.5,7.125 9.5,4.5 C9.5,2.5675 7.9325,1 6,1 Z M6,5.75 C5.31,5.75 4.75,5.19 4.75,4.5 C4.75,3.81 5.31,3.25 6,3.25 C6.69,3.25 7.25,3.81 7.25,4.5 C7.25,5.19 6.69,5.75 6,5.75 Z",
  id: "Shape",
  fill: "#00965E"
}), React.createElement("polygon", {
  id: "Path",
  points: "0 0 12 0 12 12 0 12"
}));

var SvgComponent = function SvgComponent(props) {
  return React.createElement("svg", _extends({
    width: "8px",
    height: "10px",
    viewBox: "0 0 8 10",
    version: 1.1,
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _ref);
};

export default __webpack_public_path__ + "static/media/pin.4a35c79e.svg";
export { SvgComponent as ReactComponent };